// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5833":"88a60b355172ec7ddc58","7050":"030794530c038fac387b","9224":"21ad3d64a1bf06cabb16"}[chunkId] + ".css";
};